import {
	API2_URL, PROJECT_AGREEMENTS_REQUEST, PROJECT_AGREEMENTS, PROJECT_AGREEMENTS_LOADED, PROJECT_AGREEMENTS_CLEAR,
	PROJECT_AGREEMENTS_FAIL} from "../store/config";
import {sessionService} from "redux-react-session";
import fetch from "isomorphic-fetch";
import {newNotification} from "./notifications";
import _ from "lodash";
import FileSaver from "file-saver";
import {fetchRevisionAgreements} from './revision';

export const fetchProjectAgreementsWithRevision = (modality, state, mun = undefined, type) => {
	return dispatch => {
		dispatch(projectAgreementsRequest());
		return dispatch(fetchRevisionAgreements(type, modality, state, mun))
			.then(revision => {
				if(revision.error) {
					return dispatch(projectAgreementsFail(revision.error))
				} else {
					return dispatch(projectAgreements(modality, state, mun));
				}
			});
	};
};

export const projectAgreements = (modality, state, mun = undefined) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(projectAgreementsRequest());
			dispatch(projectAgreementsClear());

			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			return fetch(`${API2_URL}/projects/agreements/agency/${modality}/${state}${mun ? '/'+mun : ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(projectAgreementsData(json)),
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
						return dispatch(projectAgreementsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
};

export const projectAgreementsExport = (modality, state, mun = undefined) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			}
			let fileName= undefined;
			dispatch(projectAgreementsRequest());
			return fetch(`${API2_URL}/projects/agreements/agency/bank-account-confirmation-pdf/${modality}/${state}${mun ? '/'+mun : ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						let header = result.headers.get('Content-Disposition','attachment')
						fileName = header.match(/filename="(.+)"/)[1];
						return result.blob();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					blob => {
						FileSaver.saveAs(blob,fileName);
						dispatch(projectAgreementsLoaded())
					},
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
						return dispatch(projectAgreementsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const projectAgreementsSave = (modality, state, mun = undefined, values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(projectAgreementsRequest());
			let body = new FormData();

			if(modality === 'modalidad-i'){
				_.mapKeys(values.agency.fiscal_entity, (o,j) => {
					if(o !== undefined) {
						if(!_.isObject(o) &&  !_.startsWith(o, 'http://')){
							body.append(`fiscal_entity[${j}]`, o);
						}else if(_.isObject(o) && !_.isEmpty(o) && o[0] !== undefined) {
							body.append(`fiscal_entity[${j}]`, o[0]);
						}
					}
				});

				_.mapKeys(values.documents, (o,j) => {
					if(o !== undefined) {
						if(!_.isObject(o) &&  !_.startsWith(o, 'http://')){
							body.append(j, o);
						}else if(_.isObject(o) && !_.isEmpty(o) && o[0] !== undefined) {
							body.append(j, o[0]);
						}
					}
				});
			}else {
				_.mapKeys(values.documents, (o,j) => {
					if(o !== undefined) {
						if(!_.isObject(o) &&  !_.startsWith(o, 'http://')){
							body.append(j, o);
						}else if(_.isObject(o) && !_.isEmpty(o) && o[0] !== undefined) {
							body.append(j, o[0]);
						}
					}
				});
			}

			if(values.finished){
				body.append('finished', values.finished);
			}

			const options = {
				headers: {
					'Accept': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: body
			}

			return fetch(`${API2_URL}/projects/agreements/agency/${modality}/${state}${mun ? '/'+mun : ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title:'¡Éxito!', content: json.message ? json.message:'Se guardaron correctamente los cambios', type: 'success'}));
						return dispatch(projectAgreementsData(json))
					},
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
						return dispatch(projectAgreementsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const projectAgreementsData = (json) => {
	let revisions = []; let documents = {};

	if(json.data && !_.isEmpty(json.data.documents)){
		_.map(json.data.documents,(item) => {
			documents = {
				...documents,
				[item.documentable_subtype]: item.file
			}
		})
	}

	if(json.data && !_.isEmpty(json.data.agency) && !_.isEmpty(json.data.agency.documents)){
		_.map(json.data.agency.documents,(item) => {
			documents = {
				...documents,
				[item.documentable_subtype]: item.file
			}
		})
	}

	if(!_.isEmpty(json.revisions)){
		_.map(json.revisions, (data) => {
			revisions.push({
				...data,
				body: JSON.parse(data.body)
			})
		})
	}

	return {
		type: PROJECT_AGREEMENTS,
		isFetching: false,
		payload: {
			...json.data,
			finished: json.finished,
			documents: documents
		},
		documents_items: json.documents_items,
		editable: json.editable,
		revisions: revisions,
		permissions: json.permissions,
		version: json.version,
		timestamp: Date.now()
	}
}

const projectAgreementsRequest = () => {
	return {
		type: PROJECT_AGREEMENTS_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const projectAgreementsLoaded = () => {
	return {
		type: PROJECT_AGREEMENTS_LOADED,
		isFetching: false,
		timestamp: Date.now()
	}
}

const projectAgreementsClear = () => {
	return {
		type: PROJECT_AGREEMENTS_CLEAR,
		payload: {},
		timestamp: Date.now()
	}
}

const projectAgreementsFail = (error) => {
	return {
		type: PROJECT_AGREEMENTS_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}


// WEBPACK FOOTER //
// ./src/actions/agreements.js